import { DocsEntityDraftChangeType, } from "./SDKDocsEntityDraftState";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var DocsEntityApprovalStateType;
(function (DocsEntityApprovalStateType) {
    DocsEntityApprovalStateType["Draft"] = "Draft";
    DocsEntityApprovalStateType["ReadyForReview"] = "ReadyForReview";
    DocsEntityApprovalStateType["ChangesRequested"] = "ChangesRequested";
    DocsEntityApprovalStateType["ReadyForPublish"] = "ReadyForPublish";
    DocsEntityApprovalStateType["Published"] = "Published";
})(DocsEntityApprovalStateType || (DocsEntityApprovalStateType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsEntityApprovalState {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, draftState) {
        if (!model) {
            if (draftState) {
                if (draftState.changeType === DocsEntityDraftChangeType.Deleted) {
                    this.state = DocsEntityApprovalStateType.ReadyForPublish;
                }
                else {
                    this.state = DocsEntityApprovalStateType.Draft;
                }
            }
            else {
                this.state = DocsEntityApprovalStateType.Published;
            }
        }
        else if (model.approvalState === "ReadyForReview") {
            this.state = DocsEntityApprovalStateType.ReadyForReview;
        }
        else if (model.approvalState === "ChangesRequested") {
            this.state = DocsEntityApprovalStateType.ChangesRequested;
        }
        else if (model.approvalState === "Approved") {
            this.state = DocsEntityApprovalStateType.ReadyForPublish;
        }
        else {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error(`Unknown approval state ${model.approvalState}`);
        }
        this.updatedByUserId =
            model && "updatedByUserId" in model ? model === null || model === void 0 ? void 0 : model.updatedByUserId : null;
    }
}
